import { Link, useParams, useOutletContext } from "react-router-dom"
import { useComputed } from "@preact/signals-react"

import Table from 'react-bootstrap/Table'

import TimestampWithUTCTooltip from "../../components/TimestampWithUTCTooltip"

import { installationListSignal as installationsSignal, installationListLoadingSignal as loadingSignal, installationListErrorSignal as errorSignal } from "../../state/signals/installationSignals.js"
import { fetchInstallationList } from "../../state/actions/installationActions.js"
import { useEffect } from "react"

function Dashboard() {

	const { beId } = useParams()
    const { config, accessToken, userPermissionsSummary, currentBusinessEntityId, accordionData: sidebarAccordionData  } = useOutletContext()
	let referenceGuid = config && config.referenceGuid ? config.referenceGuid : null

	useEffect(() => {
		if (userPermissionsSummary.value && userPermissionsSummary.value.canViewInstallations) {
			fetchInstallationList(beId, config, accessToken)
		}
	}, [userPermissionsSummary.value])

	useEffect(() => {
		fetchInstallationList(beId, config, accessToken)
	},[beId])

	const sortedDataSignal = useComputed(() => {
		try {
			let _sortedData = [...installationsSignal.value]
			return _sortedData.sort((a, b) => {
				if (a.lastUpdatedAt < b.lastUpdatedAt) {
					return 1
				}
				if (a.lastUpdatedAt > b.lastUpdatedAt) {
					return -1
				}
				return 0
			})
		} catch (x) {
			window.alert(x)
		}
	})

	const displayDataSignal = useComputed(() => {
		return sortedDataSignal.value.slice(0, 5)
	})

	function TableRow({ item }) {
		return (
			<tr>
				<td>{item.manifest.machine.nickname}</td>
				<td>{item.type == 10 ? 'New UTG' : 'Existing UTG'}</td>
				<td>{item.businessEntityId}</td>
				<td><TimestampWithUTCTooltip date={item.lastUpdatedAt}></TimestampWithUTCTooltip></td>
			</tr>
		)
	}

	function TableRows({ items }) {
		if (items && items.length) {
			const rows = items.map(item => {
				return <TableRow item={item} key={`${item.id}`} />
			})
			return (
				<tbody>{rows}</tbody>
			)
		}
		else if (items) {
			return (
				<tbody><tr><td colSpan="18" className="text-center">No recent installations</td></tr></tbody>
			)
		}
	}

	return (
		<div className="dashboard">
			<section hidden className="col-xs-6 col-sm-6 col-md-6 panel" style={{ display:"none" }}>
				<header className="panel-heading">
					<h2 className="panel-title">Alerts</h2>
				</header>
				<div className="panel-body">No Recent Alerts</div>
			</section>
			<section>
				<header>I Want to...</header>
				<div>
						<a target="_blank" rel="noreferrer" href={referenceGuid}>Read the Reference Guide</a>
						{
							userPermissionsSummary.value?.canEditInstallations && (
								<>
									<Link to={{ pathname: `/be/${beId}/installations` }} state={{ intent: 'install' }}>Install and Connect a New UTG</Link>
									<Link to={{ pathname: `/be/${beId}/installations` }} state={{ intent: 'connect' }}>Connect an existing UTG</Link>
								</>
							)
						}
						{
							userPermissionsSummary.value?.canViewInstallations && (
								<Link to={{ pathname: `/be/${beId}/installations` }}>View My Installations</Link>
							)
						}
						{
							userPermissionsSummary.value?.canEditUtgs && (
								<Link to={{ pathname: `/be/${beId}/utgs` }} state={{ intent: 'schedule' }}>Schedule a Task</Link>
							)
						}
						{
							userPermissionsSummary.value?.canViewUtgs && (
								<Link to={{ pathname:`/be/${beId}/utgs`}}>View My UTGs</Link>
							)
						}
				</div>
			</section>
			{
				userPermissionsSummary.value?.canViewInstallations && (
					<section style={{ width: "66.66666667%" }}>
						<header>Recent Installations</header>
						<div>
							{
								!loadingSignal.value ? (
									<Table striped hover size="sm" style={{overflow: 'auto'}}>
										<thead>
											<tr>
												<th>Installation Name</th>
												<th>Install Type</th>
												<th>Business Entity ID</th>
												<th>Last Updated</th>
											</tr>
										</thead>
										<TableRows items={displayDataSignal.value} />
									</Table>
								) : (
									<>Loading...</>
								)
							}
						</div>
					</section>
				)
			}
		</div>
	)
}

export default Dashboard;